<script>
	import { auth, db } from '../../helpers/firebase';
	import { navigate } from 'svelte-routing';
	import { userStore } from '../../helpers/store.js';
    import { Container, Row, Col, Card, CardBody,Button} from 'sveltestrap';
    import { Link } from 'svelte-routing';

	// Destructuring to obtain email and password from form via Event
	const handleRegisterForm = ({
		target: {
			elements: { email, password, username, organization },
		},
	}) => {
		alert("등록 기간이 종료되었습니다. 감사합니다.");
	};

	let agree_terms = false;
	let agree_privacy = false;

</script>

<div class="account-pages my-5 pt-sm-5">
	<Container>
	  <Row class="justify-content-center">
		<Col md={8} lg={8} xl={5}>
		  <Card class="overflow-hidden">
			<div class="bg-primary bg-soft">
			  <Row>
				<Col class="col-12">
				  <div class="text-primary p-4">
					<h5 class="text-primary">등록하기</h5>
					<p>KLAID 2022 Challenge 참가 등록</p>
				  </div>
				</Col>
				<!-- <Col class="col-5 align-self-end">
				  <img
					src="assets/images/profile-img.png"
					alt=""
					class="img-fluid"
				  />
				</Col> -->
			  </Row>
			</div>
			<CardBody class="pt-0">
			  <div>
				<Link to="/">
				  <div class="avatar-md profile-user-wid mb-4">
					<span class="avatar-title rounded-circle bg-light">
					  <img
						src="assets/images/klaid-logo.svg"
						alt=""
						class="rounded-circle"
						height="34"
					  />
					</span>
				  </div>
				</Link>
			  </div>
			  <div class="p-2">
				<p>등록 기간이 종료되었습니다.</p>
			  </div>
			</CardBody>
		  </Card>
		  <div class="mt-5 text-center">
			<p>
			  이미 등록하셨나요?
			  <Link to="/login" class="fw-medium text-primary">로그인</Link>
			</p>
			<!-- <p>
			  © {new Date().getFullYear()} LAW&COMPANY. 
			</p> -->
		  </div>
		</Col>
	  </Row>
	</Container>
  </div>
